import React, { FC } from 'react';
import { connect } from 'react-redux';
import Navbar from '../../../../../../components/Navbar';

import './style.scss';
import { Props } from './typing';
import SelectProduct from '../SelectProduct';
import MerchantDetails from '../MerchantDetails';
import CompanyAuthDetails from '../CompanyAuthDetails';
import BusinessInformationDetails from '../BusinessInformation';
import MandatoryDetails from '../MandatoryDetails';
import BankDetails from '../BankDetails';
import UploadDocuments from '../UploadDocuments';

const ProfileContent: FC<Props> = (props): JSX.Element => {
  const {
    currentStep,
    setCurrentStep,
    nextPage,
    prevPage,
    updateProfileDetails,
    merchantProfile,
    setMerchantProfile,
    submitForm2,
  } = props;
  return (
    <div className='profile-contentview'>
      <Navbar isKycNavBar={true} />
      <div className='content-steps'>
        {(() => {
          switch (currentStep) {
            case 0:
              return (
                <SelectProduct
                  nextPage={nextPage}
                  prevPage={prevPage}
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                  merchantProfile={merchantProfile}
                  setMerchantProfile={setMerchantProfile}
                  updateProfileDetails={updateProfileDetails}
                />
              );
            case 1:
              return (
                <MerchantDetails
                  nextPage={nextPage}
                  prevPage={prevPage}
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                  merchantProfile={merchantProfile}
                  setMerchantProfile={setMerchantProfile}
                  updateProfileDetails={updateProfileDetails}
                />
              );
            case 2:
              return (
                <CompanyAuthDetails
                  nextPage={nextPage}
                  prevPage={prevPage}
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                  merchantProfile={merchantProfile}
                  setMerchantProfile={setMerchantProfile}
                  updateProfileDetails={updateProfileDetails}
                />
              );
            case 3:
              return (
                <BusinessInformationDetails
                  nextPage={nextPage}
                  prevPage={prevPage}
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                  merchantProfile={merchantProfile}
                  setMerchantProfile={setMerchantProfile}
                  updateProfileDetails={updateProfileDetails}
                />
              );
            case 4:
              return (
                <MandatoryDetails
                  nextPage={nextPage}
                  prevPage={prevPage}
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                  merchantProfile={merchantProfile}
                  setMerchantProfile={setMerchantProfile}
                  updateProfileDetails={updateProfileDetails}
                />
              );
            case 5:
              return (
                <BankDetails
                  nextPage={nextPage}
                  prevPage={prevPage}
                  currentStep={currentStep}
                  setCurrentStep={setCurrentStep}
                  merchantProfile={merchantProfile}
                  setMerchantProfile={setMerchantProfile}
                  updateProfileDetails={updateProfileDetails}
                />
              );

              case 6:
                return (
                  <UploadDocuments
                    nextPage={nextPage}
                    prevPage={prevPage}
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    merchantProfile={merchantProfile}
                    setMerchantProfile={setMerchantProfile}
                    updateProfileDetails={updateProfileDetails}
                    submitForm2={submitForm2}
                  />
                );
          }
        })()}
      </div>
    </div>
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {})(ProfileContent);
